import React from 'react';
import { Fade, Grow, Box, IconButton } from '@mui/material';

interface ToggleIconProps {
  on: boolean;
  onToggle: () => void;
  onIcon: React.ReactNode;
  offIcon: React.ReactNode;
  timeout?: number; // default 200ms
}

export default function ToggleIcon({
  on,
  onToggle,
  onIcon,
  offIcon,
  timeout = 200,
}: ToggleIconProps) {
  return (
    <IconButton sx={{ position: 'relative' }} onClick={onToggle}>
      {/* Off state */}
      <Fade in={!on} timeout={timeout} unmountOnExit>
        <Grow in={!on} timeout={timeout}>
          <Box
            sx={{
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {offIcon}
          </Box>
        </Grow>
      </Fade>

      {/* On state */}
      <Fade in={on} timeout={timeout} unmountOnExit>
        <Grow in={on} timeout={timeout}>
          <Box
            sx={{
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {onIcon}
          </Box>
        </Grow>
      </Fade>
    </IconButton>
  );
}
